import { required, email, containsNoInteger } from '@shared/utils/validation';
export var formValidation = function (values) {
    var errors = {
        firstName: containsNoInteger(values.firstName),
        lastName: containsNoInteger(values.lastName),
        email: required(values.email) || email(values.email),
    };
    return errors;
};
